export var fireCoin = function fireCoin(confetti, theme) {
  var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    x: 0.5,
    y: 0.5
  };

  if (isInBounds(origin)) {
    confetti && confetti({
      particleCount: 1,
      startVelocity: 0,
      origin: origin,
      colors: [theme.palette.other.coin],
      shapes: ['circle'],
      gravity: 0.4
    });
  }
};
export var fireConfetti = function fireConfetti(confetti) {
  confetti && confetti({
    angle: 135,
    particleCount: 100,
    origin: {
      x: 0.5,
      y: 0.7
    }
  });
  confetti && confetti({
    angle: 45,
    particleCount: 100,
    origin: {
      x: 0.5,
      y: 0.7
    }
  });
};

var isInBounds = function isInBounds(origin) {
  return origin.x >= 0.0 && origin.x <= 1.0 && origin.y >= 0.0 && origin.y <= 1.0;
};